let initialState = {
  smartInsightsStatus: null,
  smartInsightsData: null,
  smartInsightsSearchData: null,
  smartInsightsGraphData: null,
  cardData: null,
  graphLoader: false,
  likedData: null,
  dislikedData: null,
  smartInsightsLoader: false,
};

const SmartInsights = (state = initialState, action) => {
  switch (action.type) {
    case "SET_SMART_INSIGHTS_STATUS":
      return {
        ...state,
        smartInsightsStatus: action.payload,
      };
    case "SET_SMART_INSIGHTS_DATA":
      return {
        ...state,
        smartInsightsData: action.payload,
      };
    case "SET_SMART_INSIGHTS_SEARCH_DATA":
      return {
        ...state,
        smartInsightsSearchData: action.payload,
      };
    case "SET_SMART_INSIGHTS_GRAPH_DATA":
      return {
        ...state,
        smartInsightsGraphData: action.payload,
      };
    case "SET_SMART_INSIGHTS_CARD_DATA":
      return {
        ...state,
        cardData: action.payload,
      };
    case "SET_SMART_INSIGHTS_GRAPH_LOADER":
      return {
        ...state,
        graphLoader: action.payload,
      };
    case "SET_SMART_INSIGHTS_LIKED_DATA":
      return {
        ...state,
        likedData: action.payload,
      };
    case "SET_SMART_INSIGHTS_DISLIKED_DATA":
      return {
        ...state,
        dislikedData: action.payload,
      };
    case "SET_SMART_INSIGHTS_DATALOADER":
      return {
        ...state,
        smartInsightsLoader: action.payload,
      };
    default:
      return state;
  }
};

export default SmartInsights;
